import { flow } from "fp-ts/lib/function";

import { type MetricField } from "../../../gql-generated/types";
import { computeFractionPercent } from "../../computers";
import { formatNumberNoSuffixCurried, formatPercentValue } from "../../formatters";
import {
    type FunnelItem,
    fractionFromPreviousPercentFormattedLens,
    fractionFromPreviousPercentLens,
    fractionFromTotalPercentFormattedLens,
    fractionFromTotalPercentLens,
    labelLens,
    labelPreviousLens,
    metricsLabels,
    valueFormattedLens,
} from "../../models/dimension-funnel";

export const setFunnelItemLabel =
    (fieldName: MetricField) =>
    (funnelItem: FunnelItem): FunnelItem =>
        labelLens.modify(() => metricsLabels[fieldName] ?? "")(funnelItem);

export const setFunnelItemLabelPrevious =
    (fieldName: MetricField | null) =>
    (funnelItem: FunnelItem): FunnelItem =>
        labelPreviousLens.modify(() => (fieldName ? metricsLabels[fieldName] ?? null : null))(funnelItem);

export const setFunnelItemValueFormatted =
    (isNotEnough?: boolean) =>
    (funnelItem: FunnelItem): FunnelItem => {
        const { value } = funnelItem;
        return isNotEnough ? funnelItem : valueFormattedLens.modify(formatNumberNoSuffixCurried(value))(funnelItem);
    };

export const setFunnelItemFractionPercent =
    (previousMetricValue: number | null, firstMetricValue: number | null) =>
    (funnelItem: FunnelItem): FunnelItem => {
        const { value } = funnelItem;
        return flow(
            fractionFromPreviousPercentLens.modify(computeFractionPercent(previousMetricValue, value)),
            fractionFromTotalPercentLens.modify(computeFractionPercent(firstMetricValue, value)),
        )(funnelItem);
    };

const formatFractionPercent = (fractionPercentValue: number) => () => {
    if (fractionPercentValue === Number.POSITIVE_INFINITY) {
        return "-";
    }

    return formatPercentValue(2)(fractionPercentValue);
};

export const setFunnelItemFractionsPercentFormatted = (funnelItem: FunnelItem): FunnelItem => {
    const { fractionFromPreviousPercent, fractionFromTotalPercent } = funnelItem;

    return flow(
        fractionFromPreviousPercentFormattedLens.modify(formatFractionPercent(fractionFromPreviousPercent)),
        fractionFromTotalPercentFormattedLens.modify(formatFractionPercent(fractionFromTotalPercent)),
    )(funnelItem);
};
